var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7315 1.2165C2.63878 0.430335 3.79949 -0.00166993 5 4.85133e-06C7.7615 4.85133e-06 10 2.2385 10 5C10 6.068 9.665 7.058 9.095 7.87L7.5 5L9 5C9.00006 4.21582 8.76962 3.44891 8.33733 2.79463C7.90504 2.14036 7.28997 1.62758 6.56859 1.32007C5.84721 1.01255 5.05136 0.923856 4.27998 1.06501C3.5086 1.20617 2.79573 1.57095 2.23 2.114L1.7315 1.2165ZM8.2685 8.7835C7.36122 9.56967 6.20051 10.0017 5 10C2.2385 10 0 7.7615 0 5C0 3.932 0.335 2.942 0.905 2.13L2.5 5L1 5C0.999936 5.78419 1.23038 6.5511 1.66267 7.20538C2.09496 7.85965 2.71003 8.37243 3.43141 8.67994C4.15279 8.98746 4.94864 9.07615 5.72002 8.935C6.4914 8.79384 7.20427 8.42905 7.77 7.886L8.2685 8.7835Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 1 0.999995)",
    fill: "currentColor"
  })));
};
export default SvgRefresh;